import { Button, DialogContent, DialogFooter, DialogHeader, DialogSection } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { HealthieAppointmentTypeTable, useHealthieAppointmentTypeImport } from "@tellescope/onboarding";

export interface HealthieImportDialogContentsProps {
  onImported?: () => void;
  onCancel?: () => void;
}

export const HealthieImportDialogContents = ({ onImported, onCancel }: HealthieImportDialogContentsProps) => {
  const { t } = useTranslation("appointment-reminders");
  const {
    appointmentTypes,
    isLoading,
    isError,
    allAlreadyImported,
    isImporting,
    resolvedSelectedAppointmentIds,
    allSelected,
    hasSelection,
    canImport,
    toggleAppointmentType,
    setAllSelected,
    importSelected,
  } = useHealthieAppointmentTypeImport({ onImportSuccess: () => onImported?.() });

  return (
    <DialogContent divided data-testid="healthie-import-dialog" className="sm:max-w-4xl">
      <DialogHeader className="px-0">
        <h2 className="px-6 text-xl font-semibold">{t("Import from Healthie")}</h2>
        <p className="px-6 text-sm font-light text-muted-foreground">
          {t("Select the appointment types you'd like to sync from Healthie")}
        </p>
      </DialogHeader>
      <DialogSection className="h-[400px] overflow-hidden">
        <HealthieAppointmentTypeTable
          appointmentTypes={appointmentTypes}
          isLoading={isLoading}
          isError={isError}
          allAlreadyImported={allAlreadyImported}
          selectedAppointmentTypeIds={resolvedSelectedAppointmentIds}
          allSelected={allSelected}
          hasSelection={hasSelection}
          onToggleAppointmentType={toggleAppointmentType}
          onToggleAll={setAllSelected}
        />
      </DialogSection>
      <DialogFooter className="bg-muted rounded-b-md">
        <Button variant="outline" onClick={onCancel} data-testid="healthie-import-cancel">
          {t("Cancel")}
        </Button>
        <Button
          onClick={importSelected}
          loading={isImporting}
          disabled={!canImport || !hasSelection}
          data-testid="healthie-import-submit"
        >
          {t("Import")}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
